module.exports = require('es6-promise').Promise;



//////////////////
// WEBPACK FOOTER
// ./~/es6-promise-promise/index.js
// module id = 46
// module chunks = 0